export default "__VITE_ASSET__dfbf361c__"